import { render, staticRenderFns } from "./DefList.vue?vue&type=template&id=f0ff127a&"
import script from "./DefList.vue?vue&type=script&lang=js&"
export * from "./DefList.vue?vue&type=script&lang=js&"
import style0 from "./DefList.vue?vue&type=style&index=0&id=f0ff127a&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0ff127a')) {
      api.createRecord('f0ff127a', component.options)
    } else {
      api.reload('f0ff127a', component.options)
    }
    module.hot.accept("./DefList.vue?vue&type=template&id=f0ff127a&", function () {
      api.rerender('f0ff127a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefList.vue"
export default component.exports